//第一步我们先引入axios模块
import axios from "axios";
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import evn  from '@/utils/evn.js';
 
//第二步我们创建一个axios实例对象,然后用函数Factory封装一下
const service = axios.create({
	baseURL: evn.baseURL,
	timeout: 30000
})

service.interceptors.request.use(config => {
	let token = localStorage.getItem('londEssage');
	if (token) {
		config.headers.Authorization = JSON.parse(token).accessToken;
	}
	return config;
}, function(error) {
	return Promise.reject(error);
})


service.interceptors.response.use(response => {
	if(response.data.code == 401){
		let token = localStorage.getItem('londEssage');
		axios.post('https://mobile.jingkashou.com/api/app-api/member/auth/refresh-token?refreshToken='+JSON.parse(token)?.refreshToken).then(res=>{
			if(res.data.data){
				localStorage.setItem('londEssage', JSON.stringify(res.data.data));
				location.reload()	
				return false;
			}else{
				let information = localStorage.getItem('londEssage');
				if(information){
					ElMessage({
						message: '登陆过期请重新登陆',
						type: 'error'
					});
					localStorage.removeItem('londEssage');
					localStorage.removeItem('information');
					location.reload()	
				}
			}
			return false;
		})
	}
	return response.data;
}, function(error) {
	return Promise.reject(error);
});

export default service;